import { httpAuth } from "@/api/httpAuth";
import { httpPublic } from "@/api/httpPublic";
import { httpWorkflowAuth } from "@/api/httpWorkflow";
import { workflowTokenStore } from "@/api/helpers/workflowTokenStore";

export const workflowRequests = {
  create_workflow_instance: function ({ context, data, headers } = {}) {
    return httpPublic
      .post("/v1/workflow/create_workflow_instance", { context, headers, json: data })
      .json();
  },

  eligible_states: function ({ context } = {}) {
    return httpAuth.post("/v1/workflow/eligible_states", { context }).json();
  },

  get_last_question: function ({ context, data, headers }) {
    const {
      headers: workflowHeaders,
      instance,
      url,
    } = workflowRequestBuilder(
      headers,
      "/v1/patient/assessment/last_question",
      "/v1/patient/assessment/public_last_question",
    );

    return instance.post(url, { context, headers: workflowHeaders, json: data }).json();
  },

  get_next_question: function ({ context, data, headers }) {
    const {
      headers: workflowHeaders,
      instance,
      url,
    } = workflowRequestBuilder(
      headers,
      "/v1/patient/assessment/get_question",
      "/v1/patient/assessment/public_get_question",
    );

    return instance.post(url, { context, headers: workflowHeaders, json: data }).json();
  },

  get_schedule_info: function ({ context, data, headers } = {}) {
    return httpAuth.post("/v1/referral/get_schedule_info", { context, headers, json: data }).json();
  },

  get_workflow: function ({ context, data } = {}) {
    return httpPublic.post("/v1/workflow/get_workflow", { context, json: data }).json();
  },

  intake_get_additional_appointments: function ({ context, data, headers } = {}) {
    return httpAuth
      .post("/v1/referral/get_other_days_for_patient_intake_appointment", {
        context,
        headers,
        json: data,
      })
      .json();
  },

  screening: function ({ context, data, headers } = {}) {
    return httpAuth.post("/v1/referral/screening", { context, headers, json: data }).json();
  },

  submit_next_question: function ({ context, data, headers }) {
    const {
      headers: workflowHeaders,
      instance,
      url,
    } = workflowRequestBuilder(
      headers,
      "/v1/patient/assessment/submit_question",
      "/v1/patient/assessment/public_submit_question",
    );

    return instance.post(url, { context, headers: workflowHeaders, json: data }).json();
  },

  undo_state_and_backtrack_one_node: function ({ context, data, headers } = {}) {
    return httpPublic
      .post("/v1/workflow/undo_state_and_backtrack_one_node", { context, headers, json: data })
      .json();
  },

  update_state_and_get_next_node: function ({ context, data, headers } = {}) {
    return httpPublic
      .post("/v1/workflow/update_state_and_get_next_node", { context, headers, json: data })
      .json();
  },
};

function workflowRequestBuilder(headers, authUrl, publicUrl) {
  if (workflowTokenStore.get()?.idToken) {
    return { headers, instance: httpWorkflowAuth, url: authUrl };
  }

  if (headers["dob"] && headers["X-Entity-Type"]) {
    // Spread first to avoid mutating the caller's headers object
    const newHeaders = { ...headers, Authorization: "DOB " + headers["dob"] };

    delete newHeaders["dob"];

    return { headers: newHeaders, instance: httpPublic, url: publicUrl };
  }

  throw new Error(
    "workflowRequestBuilder: no auth available — workflow token is null and DOB headers are missing",
  );
}
